import { request, METHODS } from '../axiosInstances';

export default {
  get: (params = {}) => request(METHODS.GET, `/confirmed/`, { params }),
  getCount: (params = {}) => request(METHODS.GET, `/confirmed/count/`, { params }),
};
